module.exports = __webpack_public_path__ + "4d91d0c5b647690109c1a7735e964396.svg";